import React from 'react';
import { Blocks, Bot, Braces, Database, FolderOpen, KeyRound, Map, MessageCircle, MessagesSquare, MonitorCog, MousePointerClick, PlugZap, Send, Sparkles, Radio, Share2, Users, WandSparkles, Workflow } from 'lucide-react';
const ICONS = {
  blocks: Blocks,
  bot: Bot,
  braces: Braces,
  database: Database,
  'folder-open': FolderOpen,
  'key-round': KeyRound,
  map: Map,
  'message-circle': MessageCircle,
  'messages-square': MessagesSquare,
  'monitor-cog': MonitorCog,
  'mouse-pointer-click': MousePointerClick,
  'plug-zap': PlugZap,
  radio: Radio,
  send: Send,
  'share-2': Share2,
  sparkles: Sparkles,
  users: Users,
  'wand-sparkles': WandSparkles,
  workflow: Workflow
};
export function FeatureIcon({
  name,
  size = 18,
  className = ''
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const Icon = ICONS[name as keyof typeof ICONS] || Sparkles;
  return <Icon size={size} className={className} aria-hidden="true" data-id="element-2739" data-mp="1d71zux514ycj" />;
}